module.exports = __webpack_public_path__ + "assets/img/no-report.8a5fe5be.png";